import { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Input from './Part/Input.jsx';
import Message from './Part/Message.jsx';
import iconUser from './icons/user.svg';
import apiService from '../services/axiosAuth';

class ResetPasswordForm extends Component {
  state = {
    error: null,
    success: null,
    info: null,
    showMessage: false,
  };

  hideMessage = () => {
    this.setState({ showMessage: false });
  };

  submit = (values) => {
    this.setState({
      error: null,
      success: null,
      showMessage: false,
    });

    apiService
      .post('/login/reset-password', {
        login: values.username?.trim(),
      })
      .then(() => {
        this.setState({
          info: this.props.intl.formatMessage({
            id: 'Resetting email is sent',
          }),
          showMessage: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 400) {
          this.setState({
            error: this.props.intl.formatMessage({
              id: 'No user for given login',
            }),
            showMessage: true,
          });
        } else {
          this.setState({
            error: this.props.intl.formatMessage({
              id: 'Something went wrong, try again later',
            }),
            showMessage: true,
          });
        }
      });
  };

  render() {
    const validationSchema = Yup.object().shape({
      username: Yup.string().required(this.props.intl.formatMessage({ id: 'This field is required' })),
    });

    return (
      <>
        {this.state.error && <Message message={this.state.error} open={this.state.showMessage} onClick={this.hideMessage} type='error' />}
        {this.state.success && (
          <Message message={this.state.success} open={this.state.showMessage} onClick={this.hideMessage} type='success' />
        )}
        {this.state.info && <Message message={this.state.info} open={this.state.showMessage} onClick={this.hideMessage} type='info' />}
        <Formik
          initialValues={{
            username: '',
          }}
          validateOnBlur
          validateOnChange
          validationSchema={validationSchema}
          onSubmit={this.submit}
          render={(props) => (
            <Form>
              <div style={{ paddingTop: '10px' }}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link className='login-link' to='/login'>
                  <FormattedMessage id='Back to sign in' />
                </Link>
              </div>
              <div className='field-box form-styles'>
                <label>Login</label>
                <br />
                <Field
                  name='username'
                  component={Input}
                  value={props.values.username}
                  hidden
                  icon={iconUser}
                  onBlur={(v) => props.setFieldValue('username', v?.trim())}
                />
                <ErrorMessage component='div' className='text-danger' name='username' />
              </div>
              <div className='login-form-button-wrapper'>
                <button type='submit' className='login-form-button'>
                  <FormattedMessage id='CHANGE PASSWORD' />
                </button>
              </div>
            </Form>
          )}
        />
      </>
    );
  }
}

ResetPasswordForm.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ResetPasswordForm);
